module.exports = __webpack_public_path__ + "img/banner6.080fb104.png";